































































































































































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { EntradaDoExtratoDeDemonstracao, GavetaDeDemonstracao, MotivoCancelamento, TipoDeEntradaDoExtratoDeDemonstracao, VendaComReferencias, VendaDemonstracaoResumida } from "@/models";
import {
	obterDisplayClienteDaDemonstracaoResumida,
} from '@/shareds/venda-shareds';
import mapErrosSefaz from "@/shareds/fiscal/tabelas/mapErrosSefaz";
import { formatarMoeda } from "@/shareds/formatadores";
import { primaryColor } from "@/plugins/vuetify";
import ClienteGridDemonstracao from "./components-grid-demonstracao/ClienteGridDemonstracao.vue";
import NotaGridDemonstracao from "./components-grid-demonstracao/NotaGridDemonstracao.vue";
import ModalidadeGridDemonstracao from "./components-grid-demonstracao/ModalidadeGridDemonstracao.vue";
import { dateTimeToPtBrFormat, dateToPtBrFormat } from "@/shareds/date/date-utils";
import AcoesGridDemonstracao from "./components-grid-demonstracao/AcoesGridDemonstracao.vue";
import Confirmacao from "./Confirmacao.vue";
import ConfirmacaoComMotivoFiscal from "./ConfirmacaoComMotivoFiscal.vue";
import DialogoDeDetalhesDaVenda from "../venda/DialogoDeDetalhesDaVenda.vue";
import { FindVendaUseCase } from "@/usecases";
import DialogoDeCancelarPagamentos from "../venda/DialogoDeCancelarPagamentos.vue";
import RodapePersonalizado from "./data-tables/RodapePersonalizado.vue";

const COR_DA_DEMONSTRACAO = '#EA8F00'
const COR_DA_VENDA = '#1B7A1B'
const COR_DA_DEVOLUCAO = '#D32F2F'

const ESTILO_DA_CRIACAO = { ponto: '#90A4AE', texto: '#455A64', fundo: '#ECEFF1', valor: COR_DA_DEMONSTRACAO }
const ESTILO_DA_REABERTURA = { ponto: '#2196F3', texto: '#1565C0', fundo: '#E3F2FD', valor: COR_DA_DEMONSTRACAO }
const ESTILO_DA_DEVOLUCAO = { ponto: '#E53935', texto: '#C62828', fundo: '#FDE8E8', valor: COR_DA_DEVOLUCAO }
const ESTILO_DA_VENDA = { ponto: '#4CAF50', texto: '#2E7D32', fundo: '#E4F4E5', valor: COR_DA_VENDA }

const ESTILOS_DAS_ENTRADAS: Record<TipoDeEntradaDoExtratoDeDemonstracao, typeof ESTILO_DA_CRIACAO> = {
	CRIACAO: ESTILO_DA_CRIACAO,
	REABERTURA: ESTILO_DA_REABERTURA,
	DEVOLUCAO: ESTILO_DA_DEVOLUCAO,
	SAIU_PARA_VENDA: ESTILO_DA_VENDA,
	ORIGEM_CRIADORA: ESTILO_DA_REABERTURA,
	VENDA_FATIA: ESTILO_DA_VENDA,
	DEVOLUCAO_FATIA: ESTILO_DA_DEVOLUCAO,
	NOVA_DEMO_FATIA: ESTILO_DA_REABERTURA,
}

const ROTULOS_DAS_ENTRADAS: Record<TipoDeEntradaDoExtratoDeDemonstracao, string> = {
	CRIACAO: 'Criação',
	REABERTURA: 'Reabertura',
	DEVOLUCAO: 'Devolução',
	SAIU_PARA_VENDA: 'Saiu p/ venda',
	ORIGEM_CRIADORA: 'Origem (criadora)',
	VENDA_FATIA: 'Venda (fatia)',
	DEVOLUCAO_FATIA: 'Devolução (fatia)',
	NOVA_DEMO_FATIA: 'Nova demo (fatia)',
}

@Component({
	components: {
		ClienteGridDemonstracao,
		NotaGridDemonstracao,
		ModalidadeGridDemonstracao,
		AcoesGridDemonstracao,
		Confirmacao,
		ConfirmacaoComMotivoFiscal,
		DialogoDeDetalhesDaVenda,
		DialogoDeCancelarPagamentos,
		RodapePersonalizado,
	},
})
export default class GridDeDemonstracoes extends Vue {
	@Ref() confirmacao!: Confirmacao
	@Ref() dialogoDeDetalhesDaVenda!: DialogoDeDetalhesDaVenda
	@Ref() confirmacaoComMotivoFiscal!: ConfirmacaoComMotivoFiscal
	@Ref() dialogoDeCancelarPagamentos!: DialogoDeCancelarPagamentos
	@Ref() confirmarEmail!: Confirmacao
	@Ref() rodapePersonalizado!: RodapePersonalizado
	@Prop({ type: Array, required: true }) gavetas!: GavetaDeDemonstracao[]
	@Prop({ type: Number, required: false }) total?: number
	@Prop({ type: Boolean, required: true }) loading!: boolean
	@Prop({ type: Object }) paginacao!: { page: number; itemsPerPage: number; itemsLength: number }
	@Prop({ type: Number, default: 0 }) totalEmAberto!: number

	dateTimeToPtBrFormat = dateTimeToPtBrFormat
	dateToPtBrFormat = dateToPtBrFormat
	corDoTotalDaDemonstracao = COR_DA_DEMONSTRACAO
	findVendaUseCase = new FindVendaUseCase()
	vendaControlada: VendaDemonstracaoResumida | null = null
	vendaDetalhada: VendaComReferencias | null = null
	extratosAlternados: Record<string, boolean> = {}

	get variaveisDeCor() {
		return { '--cor-da-gaveta': primaryColor() }
	}

	get gavetasFormatadas() {
		return this.gavetas.map(gaveta => ({
			...gaveta,
			linha: this.formatarLinha(gaveta.cabecalho),
		}))
	}

	get textoDeDemonstracoesEmAberto() {
		return `${this.totalEmAberto} ${this.totalEmAberto === 1 ? 'demonstração' : 'demonstrações'} em aberto`
	}

	formatarLinha(venda: VendaDemonstracaoResumida) {
		return {
			...venda,
			displayCliente: obterDisplayClienteDaDemonstracaoResumida(venda),
			displayTotalDaVenda: formatarMoeda(venda.total),
			displayStatusDaNota: this.displayStatusDaNota(venda),
			displayNfSerie: this.displayNfSerie(venda),
		}
	}

	displayStatusDaNota(venda: VendaDemonstracaoResumida) {
		return venda && mapErrosSefaz[venda.status]
			? venda.possuiNotaNaoEletronica ?
				'Não eletrônica'
				:
				venda.status + ' - ' + mapErrosSefaz[venda.status]
			: venda?.status || ''
	}

	displayNfSerie(venda: VendaDemonstracaoResumida) {
		const nota = venda.notaFiscal;
		return nota
			? venda.possuiNotaNaoEletronica ?
				`NE ${nota}`
				:
				`${venda.modeloNF} ${nota}`
			: '';
	}

	estaCancelada(situacao: string) {
		return situacao === 'CANCELADA'
	}

	legendaDoIdentificador(gaveta: GavetaDeDemonstracao) {
		if (gaveta.quantidadeDeOrigens) return `criada por ${gaveta.quantidadeDeOrigens} bags de origem`
		if (gaveta.aberta) return ''
		return gaveta.devolvidaEm ? `devolvida em ${this.diaEMes(gaveta.devolvidaEm)}` : 'devolvida'
	}

	legendaDoTotal(gaveta: GavetaDeDemonstracao) {
		if (gaveta.quantidadeDeOrigens && gaveta.aberta) return `saldo das ${gaveta.quantidadeDeOrigens} origens — cliente levou`

		if (!gaveta.aberta) {
			const pecas = gaveta.quantidadeDePecas
			if (!pecas) return 'devolvida por completo'
			return `${this.pecas(pecas)} — ${pecas === 1 ? 'devolvida' : 'devolvidas'} por completo`
		}

		const novas = gaveta.quantidadeDePecasNovas
		if (novas && gaveta.identificadorDaBagAnterior) {
			const sufixo = gaveta.identificadorDaBagAnterior.split('-').pop()
			return `${this.pecas(novas)} ${novas === 1 ? 'nova' : 'novas'} — ${novas === 1 ? 'diferente' : 'diferentes'} das de ${sufixo}`
		}

		return ''
	}

	pecas(quantidade: number) {
		return `${quantidade} ${quantidade === 1 ? 'peça' : 'peças'}`
	}

	diaEMes(data: Date) {
		return dateToPtBrFormat(data).slice(0, 5)
	}

	estaExpandida(gaveta: GavetaDeDemonstracao) {
		const alternada = this.extratosAlternados[gaveta.cabecalho.id]
		return alternada === undefined ? this.gavetas.length === 1 : alternada
	}

	alternarExtrato(gaveta: GavetaDeDemonstracao) {
		this.$set(this.extratosAlternados, gaveta.cabecalho.id, !this.estaExpandida(gaveta))
	}

	estiloDaEntrada(tipo: EntradaDoExtratoDeDemonstracao['tipo']) {
		return ESTILOS_DAS_ENTRADAS[tipo]
	}

	rotuloDaEntrada(tipo: EntradaDoExtratoDeDemonstracao['tipo']) {
		return ROTULOS_DAS_ENTRADAS[tipo]
	}

	valorEmReais(valor: number) {
		return `${valor < 0 ? '-' : ''}R$ ${formatarMoeda(Math.abs(valor))}`
	}

	async handleAcaoClicada(acao: string, venda: VendaDemonstracaoResumida) {
		this.vendaControlada = venda;

		if(acao === "detalhes" || acao === "enviar-email"){
			this.vendaDetalhada = await this.findVendaUseCase.getVendaComReferencias(venda.id)
		}
		this.$nextTick(() => {
			if (acao === "cancelar") this.confirmacao.mostrar();
			else if (acao === "cancelar-com-motivo") this.confirmacaoComMotivoFiscal.mostrar();
			else if (acao === "detalhes") this.dialogoDeDetalhesDaVenda.mostrar(this.vendaDetalhada);
			else if (acao === 'cancelar-pagamento') this.dialogoDeCancelarPagamentos.mostrar(venda)
			else if (acao === 'enviar-email') this.confirmarEmail.mostrar()
		});
	}

	cancelarVenda(venda: VendaDemonstracaoResumida, motivoDoCancelamentoFiscal?: MotivoCancelamento) {
		this.$emit("confirmarCancelamento", venda, motivoDoCancelamentoFiscal)
		this.vendaControlada = null
	}

	enviarPorEmail() {
		this.$emit("enviarEmail", this.vendaDetalhada)
		this.vendaControlada = null
	}

	navegar(page) {
		this.$emit("paginacaoDemonstracao", page)
	}
}
